import { UserCredits } from '../models/store';
import { placActionNames } from './actionNames';
import { GenerateScanID, SetUserCredits, UserUploadedFile } from './actions';

const setUserCredits = (userCredits: UserCredits): SetUserCredits => ({
  type: placActionNames.SET_USER_CREDITS,
  userCredits,
});

const userUploadedFile = (fileName: string): UserUploadedFile => ({
  type: placActionNames.USER_UPLOADED_FILE,
  fileName,
});

const systemGeneratedScanId = (scanID: string): GenerateScanID => ({
  type: placActionNames.SYSTEM_GENERATED_SCAN_ID,
  scanID,
});

export const controlActions = { setUserCredits, userUploadedFile, systemGeneratedScanId };
